import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, PLATFORM_ID, ViewChild } from '@angular/core';

import { EMRService } from 'app/EMR/EMR.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EyecheckComponent } from 'app/EMR/eyecheck/eyecheck.component';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { HelplistService } from 'app/helplist.service';
import { isPlatformBrowser } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-Vision',
  templateUrl: './Vision.component.html',
  styleUrls: ['./Vision.component.scss']
})
export class VisionComponent implements OnInit {
  destroyvision$: Subject<boolean> = new Subject<boolean>();

  isheader:boolean=false;
  @Input() showvisionnmodel:any;
  @Output() parentdata :EventEmitter<any> = new EventEmitter();

 private prismvalue:any=[];
 private vaValue:any=[];
 private inputtype:string=null;
 private allowtablevalue:number=0;
 private enabledisablebtn:boolean =false;
  @ViewChild('dvunaidedOd') dvunaidedOd: ElementRef;
  @ViewChild('dvunaidedOs') dvunaidedOs: ElementRef;
  @ViewChild('nvunaidedOd') nvunaidedOd: ElementRef;
  @ViewChild('nvunaidedOs') nvunaidedOs: ElementRef;
  @ViewChild('dvwithGlassOd') dvwithGlassOd: ElementRef;
  @ViewChild('dvwithGlassOs') dvwithGlassOs: ElementRef;
  @ViewChild('nvwithGlassOd') nvwithGlassOd: ElementRef;
  @ViewChild('nvwithGlassOs') nvwithGlassOs: ElementRef;
  @ViewChild('dvpinholeOd') dvpinholeOd: ElementRef;
  @ViewChild('dvpinholeOs') dvpinholeOs: ElementRef;
  @ViewChild('nvpinholeOd') nvpinholeOd: ElementRef;
  @ViewChild('nvpinholeOs') nvpinholeOs: ElementRef;
  @ViewChild('dvbestCorrectOd') dvbestCorrectOd: ElementRef;
  @ViewChild('dvbestCorrectOs') dvbestCorrectOs: ElementRef;
  @ViewChild('nvbestCorrectOd') nvbestCorrectOd: ElementRef;
  @ViewChild('nvbestCorrectOs') nvbestCorrectOs: ElementRef;
  @ViewChild('dvclod') dvclod: ElementRef;
  @ViewChild('dvclOs') dvclOs: ElementRef;
  @ViewChild('nvclod') nvclod: ElementRef;
  @ViewChild('nvclos') nvclos: ElementRef;
 
  constructor(private emrservice: EMRService,private helplistservice:HelplistService,
    private dialog: MatDialog,@Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<VisionComponent>,
    private dashboardService: DashboardService) { }
   
  
  ngOnInit() {
    if(this.data){
      this.isheader = this.data.isheader;
     }else{
       this.isheader = false;
     }
    this.emrservice.enabledisableVision=true;
    this.prismvalue=this.helplistservice.eyevisiontypes_CYL.slice();
    this.vaValue =this.helplistservice.eyevisiontypes_VA.slice();
  }
  Checkipd($event,bvalue?:any){
    this.emrservice.enabledisableVision=false;
    if(bvalue =='r4c1'){
      this.emrservice.enabledisableUd = false;
      this.emrservice.opto.udrv1=$event.target.value;
    }else if(bvalue =='r4c2'){
      this.emrservice.enabledisableUd = false;
      this.emrservice.opto.udlv1=$event.target.value;
    }else if(bvalue =='r4c3'){
      this.emrservice.enabledisableUd = false;
      this.emrservice.opto.udnvr1=$event.target.value;
    }else if(bvalue =='r4c4'){
      this.emrservice.enabledisableUd = false;
      this.emrservice.opto.udnvl1=$event.target.value;
    }
  }


   
  getsphvalue(category: string, valuebox: string) {
    this.emrservice.ar_value_box = valuebox;
    this.emrservice.eyechkcategory = category;
    const dialogRef = this.dialog.open(EyecheckComponent, {
      panelClass: 'full-width-dialog',
      minHeight: '300px',
      maxWidth: '70vw',
      width: '100%',
      data: {
         //category: category,
        //userid: this.authService.Loggeduser.userid
      }
  
    });
  
      dialogRef.afterClosed().pipe(takeUntil(this.destroyvision$)).subscribe(result => {
      this.emrservice.enabledisableVision =false;
      //  console.log('The dialog was closed');
      //pid = result;
     // this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory.slice());
     
    });
  }
  dosedataArray:any=[];
  GetDosageMaster(doseid) {
  
    this.emrservice.GetDosageMaster(doseid,0,0).pipe(takeUntil(this.destroyvision$)).subscribe(item => {
      this.dosedataArray = [];
      this.dosedataArray = item;
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
 

   
  refReasonPOpup(parameter,type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',

      data: {
        parametertype: parameter
      }

    });

   dialogRef.afterClosed().pipe(takeUntil(this.destroyvision$)).subscribe(result => {
      if (result != 0) {
        this.emrservice.enabledisableVision =false;
        if(type ==1){
          this.emrservice.opto.visionRemarksRE=result;
        }else if(type ==2){
          this.emrservice.opto.visionRemarksLE =result;
        }else if(type ==3){
          this.emrservice.opto.plproD1 =result;
        }else if(type ==4){
          this.emrservice.opto.plproD3 =result;
        }else if(type ==5){
          this.emrservice.opto.plproD4 =result;
        }else if(type ==6){
          this.emrservice.opto.plproD2 =result;
        }else if(type ==7){
          this.emrservice.opto.plodRemarks =result;
        }else if(type ==8){
          this.emrservice.opto.prodRemarks =result;
        }else if(type ==9){
          this.emrservice.opto.plproS1 =result;
        }else if(type ==10){
          this.emrservice.opto.plproS3 =result;
        }else if(type ==11){
          this.emrservice.opto.plproS4 =result;
        }else if(type ==12){
          this.emrservice.opto.plproS2 =result;
        }else if(type ==13){
          this.emrservice.opto.plosRemarks =result;
        }else if(type ==14){
          this.emrservice.opto.prosRemarks =result;
        }else if (type ==15){
          this.emrservice.opto.visionChart =result;
        }

      }
    });
  }
  
  currentMedicationModal() {
    document.getElementById("currentMedicationModal").style.display = "block"; 
  
  }
  cancelcurrentMedicationModal() {
    document.getElementById("currentMedicationModal").style.display = "none"; 
   
  }

  visionModal() {
    if(this.emrservice.visionPermission.isAddPermission ==true){
      document.getElementById("visionModal").style.display = "block"; 
    this.inputtype =null;
    this.allowtablevalue=0;
    this.emrservice.optohelplist=this.emrservice.opto;
    }else{
      this.dashboardService.openSnackBar("Add Permission Denied", "OK");
    }
   
  }
  cancelVisionModal() {
    document.getElementById("visionModal").style.display = "none"; 
    this.emrservice.optohelplist={};
  }

  updateData(){
    this.emrservice.enabledisableVision=false;
    this.emrservice.opto =this.emrservice.optohelplist;
    if(this.emrservice.optohelplist.dvbestCorrectOd !=null){
      this.emrservice.enabledisableUd = false;
      this.emrservice.opto.udrv1=this.emrservice.optohelplist.dvbestCorrectOd;
    }
     if(this.emrservice.optohelplist.dvbestCorrectOs !=null){
      this.emrservice.enabledisableUd = false;
      this.emrservice.opto.udlv1=this.emrservice.optohelplist.dvbestCorrectOs;
    }
     if(this.emrservice.optohelplist.nvbestCorrectOd !=null){
      this.emrservice.enabledisableUd = false;
      this.emrservice.opto.udnvr1=this.emrservice.optohelplist.nvbestCorrectOd;
    }
    if(this.emrservice.optohelplist.nvbestCorrectOs !=null){
      this.emrservice.enabledisableUd = false;
      this.emrservice.opto.udnvl1=this.emrservice.optohelplist.nvbestCorrectOs;
    }
    this.cancelVisionModal();
  }
  focusFunction(type ,value){
    this.inputtype =type;
    this.allowtablevalue =value;
 
  }
  selectrowVlaue(row,type){
    if(type ==this.allowtablevalue){
    
      switch(this.inputtype){
        case "dvunaidedOd": {
          this.emrservice.optohelplist.dvunaidedOd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dvunaidedOs'].nativeElement.focus();
          }
              break;
        }
        case "dvunaidedOs": {
          this.emrservice.optohelplist.dvunaidedOs = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['nvunaidedOd'].nativeElement.focus();
          }
              break;
        }
        case "nvunaidedOd": {
          this.emrservice.optohelplist.nvunaidedOd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['nvunaidedOs'].nativeElement.focus();
          }
              break;
        }
        case "nvunaidedOs": {
          this.emrservice.optohelplist.nvunaidedOs = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dvwithGlassOd'].nativeElement.focus();
          }
              break;
        }
        case "dvwithGlassOd": {
          this.emrservice.optohelplist.dvwithGlassOd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dvwithGlassOs'].nativeElement.focus();
          }
              break;
        }
        case "dvwithGlassOs": {
          this.emrservice.optohelplist.dvwithGlassOs = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['nvwithGlassOd'].nativeElement.focus();
          }
              break;
        }
        case "nvwithGlassOd": {
          this.emrservice.optohelplist.nvwithGlassOd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['nvwithGlassOs'].nativeElement.focus();
          }
              break;
        }
        case "nvwithGlassOs": {
          this.emrservice.optohelplist.nvwithGlassOs = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dvpinholeOd'].nativeElement.focus();
          }
              break;
        }
        case "dvpinholeOd": {
          this.emrservice.optohelplist.dvpinholeOd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dvpinholeOs'].nativeElement.focus();
          }
              break;
        }
        case "dvpinholeOs": {
          this.emrservice.optohelplist.dvpinholeOs = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['nvpinholeOd'].nativeElement.focus();
          }
              break;
        }
        case "nvpinholeOd": {
          this.emrservice.optohelplist.nvpinholeOd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['nvpinholeOs'].nativeElement.focus();
          }
              break;
        }
        case "nvpinholeOs": {
          this.emrservice.optohelplist.nvpinholeOs  = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dvbestCorrectOd'].nativeElement.focus();
          }
              break;
        }
        case "dvbestCorrectOd": {
          this.emrservice.optohelplist.dvbestCorrectOd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dvbestCorrectOs'].nativeElement.focus();
          }
              break;
        }
        case "dvbestCorrectOs": {
          this.emrservice.optohelplist.dvbestCorrectOs = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['nvbestCorrectOd'].nativeElement.focus();
          }
              break;
        }
        case "nvbestCorrectOd": {
          this.emrservice.optohelplist.nvbestCorrectOd = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['nvbestCorrectOs'].nativeElement.focus();
          }
              break;
        }
        case "nvbestCorrectOs": {
          this.emrservice.optohelplist.nvbestCorrectOs = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dvclod'].nativeElement.focus();
          }
              break;
        }
        case "dvclod": {
          this.emrservice.optohelplist.dvclod = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dvclOs'].nativeElement.focus();
          }
              break;
        }
        case "dvclOs": {
          this.emrservice.optohelplist.dvclOs = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['nvclod'].nativeElement.focus();
          }
              break;
        }
        case "nvclod": {
          this.emrservice.optohelplist.nvclod = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['nvclos'].nativeElement.focus();
          }
              break;
        }
        case "nvclos": {
          this.emrservice.optohelplist.nvclos = row.popupDescription;
          if (isPlatformBrowser(this.platformId)) {
            this['dvunaidedOd'].nativeElement.focus();
          }
              break;
        }
       
      }
    }else{
      this.dashboardService.openSnackBar("Select Correct Value", "OK");
    }
  }
  closedialog(){
    this.dialogRef.close();
  }
  ngOnDestroy():void {
    this.destroyvision$.next(true);
    this.destroyvision$.unsubscribe();
    this.inputtype =null;
    this.allowtablevalue =null;
  }

}
